import { StopAnalyticsDateChartData } from '../../domain/analytics/stopAnalyticsDateChartData/StopAnalyticsDateChartData';
import { StopAnalyticsDateChartDataDTO } from '../../domain/analytics/stopAnalyticsDateChartData/StopAnalyticsDateChartDataDTO';

export class StopAnalyticsMapper {
  static toDomain(entry: StopAnalyticsDateChartDataDTO[]): StopAnalyticsDateChartData[] {
    return entry.map((entry) => {
      return StopAnalyticsDateChartData.create({
        date: entry.date,
        value: {
          completed_stops: entry.value.completed_stops,
          incomplete_stops: entry.value.incomplete_stops,
          canceled_stops: entry.value.canceled_stops,
          pending_stops: entry.value.pending_stops,
        },
      });
    });
  }
}
